/* eslint-disable no-invalid-this */
// We use 'this' in functions so that it can be bound to Vue's 'this' context later

/**
 * Extract a message as string from error instance
 * @param {*} err Error to extract message for
 * @return {string} Message for error
 */
function extractErrorMessage(err) {
  if (err.response && err.response.data && err.response.data.error) {
    return err.response.data.error;
  } else if (err.message) {
    return err.message;
  } else if (typeof err === 'string') {
    return err;
  } else {
    return null;
  }
}

const errorSnackbarDefaultProps = {
  timeout: 30000,
  color: 'error',
  message: 'Something went wrong',
  bugReport: true
};

/**
 * Create an error handler callback using the specified options
 * store: Vuex store to use if neither method or handler is bound to a Vue component instance
 * showErrorModal: whether or not to show error modal. Defaults to true
 * snackbarProps: properties to pass to 'alert/show' event
 *
 * @param {*} opts  Configuration for error handler
 * @return {Function} Error handler callback
 */
function getHandler(opts = {}) {
  const outerStore = opts.store || (this ? this.$store : null);

  return function(err) {
    const store = this ? this.$store : outerStore;
    let message = 'Something went wrong';
    if (err) {
      if (err instanceof Array && err.length > 0) {
        err = err[0];
      }
      message = extractErrorMessage(err) || message;
    }

    if (opts.showErrorModal !== false) {
      store.dispatch('alert/show', {
        ...errorSnackbarDefaultProps,
        ...opts.snackbarProps,
        message
      });
    }
  };
}

const defaultHandler = getHandler();

const defaultHandlerHttp = getHandler({
  snackbarProps: {
    ...errorSnackbarDefaultProps,
    timeout: 5000,
    bugReport: false
  }
});

/**
 * Method to handle HTTP failures
 * Checks if the exception is the result of a failed HTTP request
 * If it is & the HTTP response code is not a 500 code, show error modal with shortened time &
 * no bug report
 * Otherwise show the normal error modal
 *
 * @param {Error} e Error to check
 */
function handleFailedHttp(e) {
  if (e.response && Math.floor(e.response.status / 100) !== 5) {
    defaultHandlerHttp.apply(this, [e]);
  } else {
    defaultHandler.apply(this, [e]);
  }
}

const HandlerPlugin = {
  install(Vue, opts) {
    Vue.mixin({
      methods: {
        $defaultHandler: defaultHandler,
        $defaultHandlerHttp: handleFailedHttp,
        $getHandler: getHandler
      }
    });
  }
};

export { defaultHandler, extractErrorMessage, getHandler, HandlerPlugin };
